import supplier from "../views/supplier/index.vue";
import supplier_create from "../views/supplier/create.vue";
import supplier_edit from "../views/supplier/edit.vue";
import supplier_detail from "../views/supplier/detail.vue";
import supplier_import from "../views/supplier/import.vue";

const routes = [
  {
    path: "/supplier",
    name: "supplier",
    component: supplier,
    meta: { authOnly: true },
  },
  {
    path: "/supplier/create",
    name: "supplier_create",
    component: supplier_create,
    meta: { authOnly: true },
  },
  {
    path: "/supplier/edit/:uuid",
    name: "supplier_edit",
    component: supplier_edit,
    meta: { authOnly: true },
  },
  {
    path: "/supplier/detail/:uuid",
    name: "supplier_detail",
    component: supplier_detail,
    meta: { authOnly: true },
  },
  {
    path: "/supplier/import",
    name: "supplier_import",
    component: supplier_import,
    meta: { authOnly: true },
  },
];

export default routes;
